import { createSlice } from '@reduxjs/toolkit';

export const configSlice = createSlice({
  name: 'config',
  initialState: {
    version: '0.1.0',
    navbarBreakPoint: 'xl',
    topNavbarBreakpoint: 'lg',
    themeVariants: ['light', 'dark', 'auto'],
    isFluid: true,
    isRTL: false,
    isDark: false,
    theme: 'light',
    navbarPosition: 'combo',
    navbarCollapsed: false,
    showBurgerMenu: false, // controls showing vertical nav on mobile
    currency: '$',
    isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
    navbarStyle: 'card',
    mapboxSatelliteStreetsV12URL:
      process.env.REACT_APP_LEAFLET_MAPBOX_SATELLITE_STREETS_V12_URL.replace(
        '{access_token}',
        process.env.REACT_APP_LEAFLET_MAPBOX_ACCESS_TOKEN
      ),
    mapboxSatelliteV9URL:
      process.env.REACT_APP_LEAFLET_MAPBOX_SATELLITE_V9_URL.replace(
        '{access_token}',
        process.env.REACT_APP_LEAFLET_MAPBOX_ACCESS_TOKEN
      ),
    graphQLURI: `${process.env.REACT_APP_API_URL}/graphql`,
    restURI: `${process.env.REACT_APP_API_URL}`,
    showSplash: false,
    showSplashAtLogin: true,
    showGettingStarted: false
  },
  reducers: {
    setConfig: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
      if (key === 'showSplashAtLogin') {
        localStorage.setItem(key, value);
      }
    },
    changeTheme: (state, action) => {
      const theme = action.payload;
      const isDark =
        theme === 'auto'
          ? window.matchMedia('(prefers-color-scheme: dark)').matches
          : theme === 'dark';

      document.documentElement.setAttribute(
        'data-bs-theme',
        isDark ? 'dark' : 'light'
      );
      state['theme'] = theme;
      state['isDark'] = isDark;
    }
  }
});

export const { setConfig, changeTheme } = configSlice.actions;
export default configSlice.reducer;
